import { render } from "./AnnouncementListComponent.vue?vue&type=template&id=306da20d&scoped=true&ts=true"
import script from "./AnnouncementListComponent.vue?vue&type=script&lang=ts"
export * from "./AnnouncementListComponent.vue?vue&type=script&lang=ts"

import "./AnnouncementListComponent.vue?vue&type=style&index=0&id=306da20d&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-306da20d"]])

export default __exports__